// Şifre hash'leme ve doğrulama fonksiyonları
// NOT: Bu basit hash fonksiyonlarıdır, production'da bcrypt kullanılmalıdır

/**
 * Basit hash fonksiyonu (test için)
 * Production'da bcrypt veya argon2 kullanın
 */
export const hashPassword = (password) => {
  // Basit hash algoritması
  let hash = 0
  for (let i = 0; i < password.length; i++) {
    const char = password.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash // Convert to 32bit integer
  }
  // Negatif sayıları pozitif yap
  return Math.abs(hash).toString()
}

/**
 * Şifre doğrulama
 * Hem plain text hem hash'lenmiş şifreleri kontrol eder
 */
export const verifyPassword = (inputPassword, storedPassword) => {
  // Eğer stored password hash'lenmişse
  if (storedPassword && storedPassword.length > 10 && /^\d+$/.test(storedPassword)) {
    // Hash'lenmiş şifre gibi görünüyor
    return hashPassword(inputPassword) === storedPassword
  }
  // Plain text karşılaştırma
  return inputPassword === storedPassword
}


